import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LoadingText } from './LoadingText';

const useStyle = makeStyles<{ surface: boolean }>()(
  ({ zIndex, palette }, { surface }) => ({
    backdrop: {
      zIndex: zIndex.modal + 1,
      color: surface ? 'rgba(0,0,0,0.6)' : palette.primary.contrastText,
      backgroundColor: surface
        ? palette.warmSurface.main
        : 'rgba(0, 0, 0, 0.25)',
    },
  }),
);

interface LoadingProps {
  open?: boolean;
  text?: string;
  noFade?: boolean;
  surface?: boolean;
  variant?: 'spinner' | 'dots';
}

const Loading: React.FC<LoadingProps> = ({
  open = true,
  text = '',
  surface = false,
  variant = 'spinner',
}) => {
  const { classes } = useStyle({ surface });

  return (
    <Backdrop className={classes.backdrop} open={open}>
      {variant === 'dots' ? (
        <LoadingText text={text} />
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" hidden>
            {text}
          </Typography>
          <CircularProgress color="inherit" size={150} />
          <Typography variant="h5">{text}</Typography>
        </Box>
      )}
    </Backdrop>
  );
};

export default Loading;
